import React from 'react'

const TableJobRoleStatus = ({ status }) => {
  let color
  let statusText

  if (status === 'ROLE_CLOSED') {
    color = '#000000'
    statusText = 'Role cancelled'
  } else if (status === 'EVALUATION_IN_PROGRESS') {
    color = '#F7B400'
    statusText = 'Evaluation in-progress'
  } else if (status === 'OPEN_FOR_APPLICATION') {
    color = '#3249D7'
    statusText = 'Open for applications'
  } else if (status === 'APPLICATION_CLOSED') {
    color = '#000000'
    statusText = 'Closed for applications'
  } else if (status === 'COMPLETED') {
    color = '#0FB680'
    statusText = 'Completed'
  } else if (status === 'UPCOMING') {
    color = '#000000'
    statusText = 'Upcoming'
  } else if (status === 'DRAFT') {
    color = '#B4B4B4'
    statusText = 'Draft'
  } else {
    color = '#000000'
    statusText = 'Yet to Update'
  }

  return <div style={{ color, fontWeight: 'bold' }}>{statusText}</div>
}

export default TableJobRoleStatus
